import { ReactElement } from 'react';

import LogoCharts from '@/components/icons/LogoCharts';

interface ChartComponentProps {
  data: {
    title: string;
    source: string;
  };
  chart: ReactElement;
}

export default function ChartComponent({ data, chart }: ChartComponentProps) {
  return (
    <div className='bg-card dark:border-secondary relative flex h-full min-h-[420px] flex-col rounded-2xl border-4 border-[#4A7F38] p-4 shadow-xl transition-shadow hover:shadow-2xl md:border-8 md:p-6'>
      <div className='mb-2 p-0'>
        <h3 className='text-brand-dark dark:text-brand-dark-text-primary text-xl font-bold'>
          {data.title}
        </h3>
      </div>

      <div className='mb-1 flex flex-1 items-center justify-center p-0'>
        {/* Chart implementations provide their own responsive wrapper (ChartContainer). */}
        <div className='h-full min-h-[250px] w-full rounded bg-transparent'>
          {chart}
        </div>
      </div>

      <div className='relative mt-1 flex items-end space-x-4'>
        <div className='text-brand-accent dark:text-brand-dark-text-secondary flex-1 overflow-hidden text-xs'>
          <p className='wrap-break-word whitespace-pre-wrap'>{data.source}</p>
        </div>
        <div className='shrink-0'>
          <div className='dark:text-brand-dark-text-secondary relative h-auto w-24 text-[#066653]'>
            <LogoCharts />
          </div>
        </div>
      </div>
    </div>
  );
}
